import { capitalize } from '../helpers/utils';
import { NAV_TITLE } from './NavOption';

const parsePathToTitle = (route) => {
  const aux = route.split('/');
  let showbetter = aux[aux.length - 1];
  showbetter = capitalize(showbetter);
  showbetter = showbetter.split('-');
  return showbetter.join(' ');
};

const hasDefinition = (route, key = 'title') =>
  NAV_TITLE.filter((elm) => {
    if (elm.screen.indexOf(route) !== -1) return elm[key];
    return null;
  });

export const getWordingShowName = (route) => {
  const definitionRoute = hasDefinition(route, 'titleWording');
  if (definitionRoute[0]) return definitionRoute[0].titleWording;

  return parsePathToTitle(route);
};

export const getShowName = (route) => {
  const definitionRoute = hasDefinition(route);
  if (definitionRoute[0]) return definitionRoute[0].title;

  return parsePathToTitle(route);
};
